var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.122,
    height: 107.141,
    viewBox: "0 0 107.122 107.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel",
    transform: "translate(-74 -929.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ppt-icon",
    transform: "translate(0 563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20331",
    "data-name": "Group 20331",
    transform: "translate(-315 170.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_198",
    "data-name": "Union 198",
    d: "M2384.695-14276.561a53.21,53.21,0,0,1-15.694-37.883,53.2,53.2,0,0,1,15.7-37.867,53.211,53.211,0,0,1,37.865-15.7,53.193,53.193,0,0,1,37.868,15.691,53.2,53.2,0,0,1,15.693,37.867,53.249,53.249,0,0,1-15.695,37.887,53.205,53.205,0,0,1-37.866,15.7A53.21,53.21,0,0,1,2384.695-14276.561Zm-10.712-37.883a48.635,48.635,0,0,0,48.578,48.578,48.628,48.628,0,0,0,48.579-48.578,48.623,48.623,0,0,0-48.579-48.578,48.629,48.629,0,0,0-48.578,48.594Z",
    transform: "translate(-1980 14563.999)",
    fill: "#6b6b6b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "excel-file-svgrepo-com",
    transform: "translate(104 959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32237",
    "data-name": "Path 32237",
    d: "M32.914,3H16V8.509h5.6v3.75H16v3.665h5.538v3.692H16v3.692h5.538V27H16v3.692h5.538v3.692H16v5.538H32.914a1.581,1.581,0,0,0,1.547-1.606V4.606A1.581,1.581,0,0,0,32.914,3ZM30.769,34.385H23.385V30.692h7.385Zm0-7.385H23.385V23.308h7.385Zm0-7.385H23.385V15.923h7.385Zm0-7.385H23.385V8.538h7.385Z",
    transform: "translate(13.538 2.538)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32238",
    "data-name": "Path 32238",
    d: "M0,5.334V42.668L27.692,48V0ZM17.516,33.378l-3.222-6.09a5.4,5.4,0,0,1-.378-1.252h-.05a9.48,9.48,0,0,1-.432,1.305L10.2,33.378H5.182l5.959-9.349L5.69,14.679h5.125l2.673,5.607a9.8,9.8,0,0,1,.561,1.577H14.1q.158-.548.587-1.63l2.972-5.555h4.693l-5.607,9.271,5.764,9.428-4.994,0Z",
    fill: "#6b6b6b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.71f62d3223d31eab713fee19e59df96b.svg";
export { ForwardRef as ReactComponent };